import { getStores } from '@littlebird/sdk';
import { createContext, useContext } from 'react';

import { meetingStore } from '@/features/meetings/meetings.state';

import type { RichTextJsonContent } from '@littlebird/markdown-utils';

export interface ContextChatHost {
  hideCostFooter: boolean;
  isRecording: () => boolean;
  getMeetingNotes: (
    meetingId: string
  ) => RichTextJsonContent | null | undefined;
}

export const mainWindowChatHost: ContextChatHost = {
  hideCostFooter: false,
  isRecording: () => meetingStore.recording.status === 'recording',
  getMeetingNotes: (meetingId) => {
    try {
      return getStores().meetings.get(meetingId)?.notes;
    } catch {
      return undefined;
    }
  },
};

export const ContextChatHostContext =
  createContext<ContextChatHost>(mainWindowChatHost);

export function useContextChatHost() {
  return useContext(ContextChatHostContext);
}
